import { ActiveForm } from '@components/Checkout/steps/PhoneNumberStep/ActiveForm';
import type { PhoneNumberStepProps } from '@components/Checkout/steps/PhoneNumberStep/PhoneNumberStep.types';
import { ViewOnly } from '@components/Checkout/steps/PhoneNumberStep/ViewOnly';

export const PhoneNumberStep = ({
  isActive,
  isCompleted,
  sessionId,
  directoryListings,
  phoneProviders,
  savedValues,
  isSaving,
  onSave,
}: PhoneNumberStepProps) => {
  if (isCompleted && !isActive) {
    return <ViewOnly savedValues={savedValues} />;
  }

  if (!isActive) return null;

  return (
    <ActiveForm
      sessionId={sessionId}
      directoryListings={directoryListings}
      phoneProviders={phoneProviders}
      savedValues={savedValues}
      isSaving={isSaving}
      onSave={onSave}
    />
  );
};
